export default {
  org_direction: {},
  org_directions: [],
}
